import React from 'react';

export default function () {
    return (
        <div className='student-story-page page7'>
            <div className='contents'>Let’s look into your Strengths and Growth Opportunities!</div>
        </div>
    );
}